import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackAddToCart } from './MetaPixel';
const URL_MAIN = 'https://ebookpromax.com/cart/add?id=46800282878110&quantity=1';
export function FinalCTA() {
  return <Section bg="cream-light" data-id="element-246">
      <div className="max-w-4xl mx-auto text-center" data-id="element-247">
        <h2 className="text-5xl md:text-7xl font-serif text-charcoal mb-8 leading-[1.1]" data-id="element-248">
          Tu cuerpo va a seguir envejeciendo.
          <br data-id="element-249" />
          <span className="italic text-olive font-light" data-id="element-250">
            La pregunta es: ¿Cómo?
          </span>
        </h2>

        <p className="text-xl text-charcoal-light font-light mb-16 max-w-2xl mx-auto" data-id="element-251">
          Podés seguir probando cremas que no funcionan y resignarte a perder
          vitalidad. O podés invertir en el único sistema que optimiza tu cuerpo
          desde adentro.
        </p>

        <div className="bg-olive-deep text-cream-light p-10 md:p-16 rounded-[3rem] shadow-2xl relative overflow-hidden mb-16" data-id="element-252">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-253" />

          <div className="relative z-10" data-id="element-254">
            <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-255">
              La Inversión Más Importante
            </p>
            <p className="text-2xl md:text-3xl font-serif mb-10 leading-relaxed" data-id="element-256">
              No es una casa. No es ropa.
              <br data-id="element-257" />
              <span className="italic text-gold" data-id="element-258">Es tu cuerpo.</span>
              <br data-id="element-259" />Y va a estar con vos los próximos 30, 40, 50 años.
            </p>

            <Button href={URL_MAIN} onClick={() => trackAddToCart({
            value: 17990,
            contentName: 'Wellaging Argentino - Método 360°',
            contentId: 'wellaging-argentino-360'
          })} className="text-xl px-10" subtext="Solo quedan 153 copias a $17.990" data-id="element-260">
              Quiero transformar mi forma de envejecer
            </Button>
          </div>
        </div>

        {/* P.D. Section */}
        <div className="text-left max-w-2xl mx-auto space-y-6 text-charcoal-light font-light text-lg" data-id="element-261">
          <p data-id="element-262">
            <strong className="font-serif italic text-xl text-charcoal mr-2" data-id="element-263">
              P.D.
            </strong>
            Si llegaste hasta acá, es porque algo resonó profundamente con vos.
            No ignores esa voz interior. Miles de argentinas ya dieron el paso.
            Ahora es tu turno.
          </p>
          <p data-id="element-264">
            <strong className="font-serif italic text-xl text-charcoal mr-2" data-id="element-265">
              P.P.D.
            </strong>
            Tu cuerpo está esperando que tomes esta decisión. Está esperando que
            lo cuides. Que lo optimices. Dale la oportunidad que merece.
          </p>
          <div className="pt-6" data-id="element-266">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_of_Florencia.svg/1200px-Stylized_signature_of_Florencia.svg.png" alt="Firma Florencia" className="h-12 opacity-40 grayscale" onError={e => e.currentTarget.style.display = 'none'} data-id="element-267" />
            <p className="font-serif italic mt-2 text-charcoal" data-id="element-268">
              Dra. Florencia Bertotto
            </p>
          </div>
        </div>
      </div>
    </Section>;
}